/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * FIX credential change password request
 */
export interface FixCredentialChangePasswordRequest {
  id: number;
  password?: string;
}
